import { MenuItem } from "@shopify/hydrogen/storefront-api-types"
import FacebookIcon from "~/assets/icons/FacebookIcon"
import InstagramIcon from "~/assets/icons/InstagramIcon"
import LinkedinIcon from "~/assets/icons/LinkedinIcon"
import MailHeader from "~/assets/icons/MailHeader"
import PhoneHeader from "~/assets/icons/PhoneHeader"
import PinterestIcon from "~/assets/icons/PinterestIcon"
import SearchIcon from "~/assets/icons/SearchIcon"
import TwitterIcon from "~/assets/icons/TwitterIcon"
import VisitHeader from "~/assets/icons/VisitHeader"
import YoutubeIcon from "~/assets/icons/YoutubeIcon"
import { Drawer } from "~/rs-components/global"
import Navigation from "~/rs-components/global/navigation/Navigation.client"
import WishButtonIcon from "../custom_icons/WishButtonIcon"
import { contactInfo } from "../settings"
import { wishlistButtonNextTitle, routeWishList } from "../settings/__product"
import { useState } from "react";

type SetupMenuDrawerProps = {
    onClose: () => void,
    showCategory: string | boolean,
    setShowCategory: React.Dispatch<React.SetStateAction<string | boolean>>,
    goTo: (path: string) => void,
    storeName: string,
    menuItems: MenuItem[],
    shopSettings: any
}

export default function SetupMenuDrawer({ onClose, showCategory, setShowCategory, goTo, storeName, menuItems, shopSettings }: SetupMenuDrawerProps) {
    const [menuOpen, setMenuOpen] = useState<boolean>(true); const setMenuItem = (menuOpen: boolean) => {
        setMenuOpen(menuOpen);
    }

    return (
        <>

            <div className="tabsMenu">
                <button className={`menuOption-1 ${menuOpen ? 'active' : ''}`} onClick={() => setMenuItem(true)}>Menu</button>
                <button className={`menuOption-1 ${!menuOpen ? 'active' : ''}`}onClick={() => setMenuItem(false)}>Account</button>
            </div>

            {menuOpen ? (<div className="grid tabContent-1">
                <nav className="grid gap-4 p-6 sm:gap-6 sm:px-12 sm:py-8">

                    
                    <Navigation css={""} menuItems={menuItems} showCategory={showCategory} setShowCategory={setShowCategory} onClose={onClose} mobile shopSettings={shopSettings} />

                    <div className="topUserAreaResponsive open loginCart basis-3/12 text-right mb-10">
                        <div className="topUserAreaResponsive__search-container">
                            <div className="topUserAreaResponsive__search">
                                <form action={`/products`} method="GET">
                                    <input name="search" type="search" placeholder="Search entire store here..." />
                                    <i className="fa fa-search">
                                        <button type='submit' className='buttonSearch'>
                                            <SearchIcon />
                                        </button>
                                    </i>
                                </form>
                            </div>
                        </div>
                    </div>

                    <div className="wishListResonsive">
                        {wishlistButtonNextTitle &&
                            <div className="topUserArea__login">
                                <a href={routeWishList}><WishButtonIcon />Wishlist</a>
                            </div>
                        }
                    </div>
                    <div className="iconsInformation">
                        <a className="iconsInformation__call" href={`tel:${contactInfo?.phone}`}><i><PhoneHeader /></i>Call {contactInfo?.phone}</a>
                        <a className="iconsInformation__email" href={`mailto:${contactInfo?.mailTo}`}><i><MailHeader /></i>Email us</a>
                        <a className="iconsInformation__visit" href={contactInfo?.page}><i><VisitHeader /></i>Visit us</a>
                    </div>

                    <div className="responsiveMenu__socialIcons">
                        {contactInfo?.facebook && <a href={contactInfo?.facebook}><FacebookIcon /></a>}
                        {contactInfo?.instagram && <a href={contactInfo?.instagram}><InstagramIcon /></a>}
                        {contactInfo?.twitter && <a href={contactInfo?.twitter}><TwitterIcon /></a>}
                        {contactInfo?.pinterest && <a href={contactInfo?.pinterest}><PinterestIcon /></a>}
                        {contactInfo?.youtube && <a href={contactInfo?.youtube}><YoutubeIcon /></a>}
                        {contactInfo?.linkedin && <a href={contactInfo?.linkedin}><LinkedinIcon /></a>}
                    </div>

                </nav>

            </div>) : (<div className="accountTab tabContent-2">
                
                <div className="accountTab__container">

                    <div className="accountTab__menu">
                        <a className="accountTab__item" href="/account">My Account</a>
                        <a className="accountTab__item" href={`${routeWishList}`}>My Mood Board</a>
                        <a className="accountTab__item" href="/account/login">Sign In</a>
                        <a className="accountTab__item" href="/account/register">Create an Account</a>
                        {/* <a className="accountTab__item" href="/page/store-locator">Store Locator</a> */}
                    </div>

                </div>
            </div>)}






        </>
    )
}